/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowRight: {
  name: 'arrow-right';
  data: string;
} = {
  name: 'arrow-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.646 2.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L13.793 8.5H1a.5.5 0 0 1 0-1h12.793L9.646 3.354a.5.5 0 0 1 0-.708Z" fill="currentColor"/></svg>`,
};
